import { render, staticRenderFns } from "./PurchaseRequestEdit.vue?vue&type=template&id=68c7d260&scoped=true&"
import script from "./PurchaseRequestEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestEdit.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequestEdit.vue?vue&type=style&index=0&id=68c7d260&prod&lang=scss&scoped=true&"
import style1 from "./PurchaseRequestEdit.vue?vue&type=style&index=1&id=68c7d260&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c7d260",
  null
  
)

export default component.exports